export var Labels={paymentProcessing:"Payment processing"};